export const texts = [
    [
        {
          text: 'G',
          count: 100,
          fontSize: 300,
        },
        {
          text: 'U',
          count: 300,
          fontSize: 300,
        },
        {
          text: 'M',
          count: 500,
          fontSize: 250,
        },
        {
          text: 'Gooey',
          count: 700,
          fontSize: 100,
        },
        {
          text: 'Chewy',
          count: 900,
          fontSize: 200,
        },
        {
          text: 'Gummy',
          count: 1100,
          fontSize:  175,
        },
        {
          text: 'Bubble',
          count: 1300,
          fontSize: 100,
        },
        {
          text: 'Trouble',
          count: 1500,
          fontSize: 200,
        },
        {
          text: 'GUM',
          count: 1700,
          fontSize: 400,
        },
        {
          text: '',
          count: 1900,
          fontSize: 400,
        },
      ],
      [
        {
          text: 'Fresh Limes',
          count: 100,
          fontSize: 125,
        },
        {
          text: 'Nice and Sour',
          count: 300,
          fontSize: 100,
        },
        {
          text: 'Squeeze them',
          count: 500,
          fontSize: 120,
        },
        {
          text: 'Juices flow',
          count: 700,
          fontSize: 100,
        },
        {
          text: 'Tart',
          count: 900,
          fontSize: 50,
        },
        {
          text: 'Tangy',
          count: 1100,
          fontSize: 200,
        },
        {
          text: 'Lemonade Concentrate',
          count: 1300,
          fontSize: 75,
        },
        {
          text: '',
          count: 1500,
          fontSize: 300,
        },
      ],
      [
        {
          text: 'Fry hot oil',
          count: 100,
          fontSize: 200,
        },
        {
          text: 'Watch it sizzle',
          count: 300,
          fontSize: 125,
        },
        {
          text: 'Maybe the pan is too hot',
          count: 500,
          fontSize: 100,
        },
        {
          text: 'Hmmm...',
          count: 700,
          fontSize: 200,
        },
        {
          text: 'I\'m sure it\'s fine',
          count: 900,
          fontSize: 100,
        },
        {
          text: '',
          count: 1100,
          fontSize: 10,
        },
      ],
      [
        {
          text: 'Hold on',
          count: 100,
          fontSize: 100,
        },
        {
          text: 'Don\'t forget',
          count: 300,
          fontSize: 125,
        },
        {
          text: 'Tomatoes',
          count: 500,
          fontSize: 100,
        },
        {
            text: 'Toe May Toes',
            count: 700,
            fontSize: 50,
          },
        {
          text: 'Toe Mah Toes',
          count: 900,
          fontSize: 25,
        },
        {
          text: 'Mash it up',
          count: 1100,
          fontSize: 10,
        },
        {
          text: 'Raw',
          count: 1300,
          fontSize: 10,
        },
        {
            text: '',
            count: 1500,
            fontSize: 10,
        }
      ]
];

export default texts;